export const IconPrintSkype: {
  name: 'icon_print_skype-ab23cbec22e0'
} = {
  name: 'icon_print_skype-ab23cbec22e0'
}
